import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import ResizeWindow from '../../../hoc/resizeWindow';
import {deleteForumTopic, moveForumTopic, updateForumTopic} from "../../../../creators/forums.topic";

import Avatar from '../../../components/Avatar';
import Dropdown from '../../../components/Dropdown';
import Icon from '../../../components/Icon';
import ChangeTitle from './ChangeTitle';
import MoveForum from '../../../components/MoveForum';
import Alert from '../../../components/Alert';
import {Can} from "../../../../ability-context";
import Modal from "../../../components/Modal";
import DateSince from "../../../components/Date";
import createLink from "../../../../libs/createLink";
import AdvancedEditorTopic from "../../../components/advanced-editor/AdvancedEditorTopic";
import Report from "../../../components/Report";
import {reportForumTopic} from "../../../../creators/report";
import _ from "lodash";

class CardTopics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            toggleChangeTitle: false,
            toggleMoveForum: false,
            toggleAlertDeleteArticle: false,
        };
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleStatus = this.handleStatus.bind(this);
        this.handleMoveTopic = this.handleMoveTopic.bind(this);
        this.handleAlertDeleteTopic = this.handleAlertDeleteTopic.bind(this);
        this.handleReport = this.handleReport.bind(this);
    }


    handleChangePage(page, link) {
        if (page === 1) {
            this.props.history.push(link);
        } else {
            this.props.history.push(link + '/' + page);
        }
    }

    handleStatus(type, status) {
        this.props.updateForumTopic(this.props.forumId, this.props._id, {[type]: status});
        this.props.reloadChildrens()
    }

    handleMoveTopic(forumId) {
        this.props.moveForumTopic(this.props.forumId, this.props._id, {forumId: forumId});
    }

    deleteTopic() {
        this.props.deleteForumTopic(this.props.forumId, this.props._id);
        this.props.reloadChildrens();
        this.setState({toggleAlertDeleteArticle: false});
    }

    handleReport(message){
        this.props.reportForumTopic(this.props.forumId, this.props._id, {message});
    }

    handleAlertDeleteTopic() {
        this.deleteTopic();
    }

    render() {
        let lastPost = {
            ...this.props.lastComment,
            owner: this.props.lastComment.owner ? this.props.lastComment.owner : this.props.authorName
        };
        let totalPage = this.props.count ? Math.ceil(this.props.count.comment / 20) : 0;
        let hasOwner = this.props.owner !== null && this.props.owner._id;
        let lastPostHasOwner = lastPost.owner !== null && lastPost.owner._id;
        return (
            <div className="card-subcategory">
                <div className="row full responsive-active-640 mb-8">
                    {!this.props.isApproved && (
                        <span className="badge closed">Refusé</span>
                    )}
                    {!this.props.isOpened && (
                        <span className="badge closed" title="Le modérateur interdit toute réponse sur ce sujet">Verrouillé</span>
                    )}
                    {this.props.isPinned && (
                        <span className="badge pinned" title="Cette discussion est toujours affichée en premier">Épinglé</span>
                    )}
                    {this.props.isPoll && (
                        <span className="badge poll">Sondage</span>
                    )}
                    {/*TODO: right*/}
                    <Can action={"moderation"} subject={this.props} modelName="Topic">
                        <div className="topic-moderation answer-topic-admin-button responsive-hidden-640">
                            <Dropdown align="right" activableComponent={(
                                <Icon type="cog"/>
                            )}>
                                <ul className="dropdown-menu">
                                    <Can action={"update"} subject={this.props} modelName="Topic">
                                        <li className="menu-item" onClick={() => this.setState({toggleChangeTitle: true})}><Icon
                                            type="pencil"/> Modifier le titre
                                        </li>
                                    </Can>
                                    <Can action={"update"} subject={this.props} modelName={"Topic"}>
                                        <li className="menu-item"
                                            onClick={() => this.setState({toggleChangeContent: true})}><Icon
                                            type="pencil"/>Modifier le contenu
                                        </li>
                                    </Can>
                                    <Can action={"is-pinned"} subject={this.props} modelName="Topic">
                                        <li className="menu-item"
                                            onClick={() => this.handleStatus('isPinned', !this.props.isPinned)}><Icon
                                            type="thumb-tack"/> {this.props.isPinned ? "Désépingler" : "Epingler"}</li>
                                    </Can>
                                    <Can action={"is-opened"} subject={this.props} modelName="Topic">
                                        <li className="menu-item"
                                            onClick={() => this.handleStatus('isOpened', !this.props.isOpened)}><Icon
                                            type={this.props.isOpened ? 'lock' : 'unlock'}/> {this.props.isOpened ? "Fermer" : "Ouvert"}
                                        </li>
                                    </Can>
                                    <Can action={"move"} subject={this.props} modelName="Topic">
                                        <li className="menu-item" onClick={() => this.setState({toggleMoveForum: true})}><Icon
                                            type="long-arrow-right"/> Déplacer
                                        </li>
                                    </Can>
                                    <Can action={"is-approved"} subject={this.props} modelName="Topic">
                                        <li className="menu-item"
                                            onClick={() => this.handleStatus('isApproved', !this.props.isApproved)}><Icon
                                            type={this.props.isApproved === false ? 'check' : 'minimize'}/> {this.props.isApproved === false ? "Accepter" : "Refuser"}
                                        </li>
                                    </Can>
                                    <Can action={"delete"} subject={this.props} modelName="Topic">
                                        <li className="menu-item"
                                            onClick={() => this.setState({toggleAlertDeleteArticle: true})}><Icon
                                            type="close"/> Supprimer
                                        </li>
                                    </Can>
                                    <Can action={"report"} subject={this.props} modelName="Topic">
                                        <li className="menu-item">
                                            <Icon type="report"/>
                                            <Report _id={this.props._id}
                                                    kind={"topics"}
                                                    handleReport={this.handleReport}
                                                    title={this.props.title}/>
                                        </li>
                                    </Can>
                                </ul>
                            </Dropdown>
                        </div>
                    </Can>
                </div>
                <div className="wrapper-left">
                    {/*<div className="unread">
                        <div className="notification-dot" />
                    </div>*/}
                    <div className="wrapper-card-subcategory">
                        <div className="wrapper-title">
                            <div className="title">
                                <div className="before-title responsive-hidden-640">
                                    {!this.props.isApproved && (
                                        <span className="badge closed">Refusé</span>
                                    )}
                                    {!this.props.isOpened && (
                                        <span className="badge closed" title="Le modérateur interdit toute réponse sur ce sujet">Verrouillé</span>
                                    )}
                                    {this.props.isPinned && (
                                        <span className="badge pinned" title="Cette discussion est toujours affichée en premier">Épinglé</span>
                                    )}
                                    {this.props.isPoll && (
                                        <span className="badge poll">Sondage</span>
                                    )}
                                </div>
                                <Link
                                    to={createLink("forumTopic", {categoryParent : {slug : _.get(this.props,"match.params.slugParent") || ""}, category : {slug : _.get(this.props,"forum.slug") || "", "_id" : _.get(this.props,"forum._id")}, topic : {"_id" : _.get(this.props,"_id"), slug : _.get(this.props,"slug") || ""}}) }>{this.props.title.length >= 55 ? this.props.title.substring(0, 55) + "..." : this.props.title} </Link>
                            </div>
                            <div className="row align-center started-by">Débuté par&nbsp;
                                {hasOwner ? <Link className={"username"} to={createLink("userProfile", this.props.owner)}>
                                        {this.props.owner.username}
                                </Link> :
                                    <div>{this.props.authorName}</div>}
                                ,&nbsp;{this.props.createdAt ?
                                    <DateSince
                                        date={this.props.createdAt}
                                        prefix={true}
                                        currentFormat={true}
                                    />
                                    : ''}</div>

                            {/*{totalPage >1 ? <Pagination pagesCount={totalPage} handleChangePage={this.handleChangePage} previousShow={false} nextShow={false} link={`/topic/${this.props._id}-${this.props.slug}`} paginationLength={4} /> : ''}*/}
                        </div>
                        <div className="wrapper-infos">
                            <div className="subjects"><span>{this.props.count && this.props.count.view}</span>&nbsp;vues
                            </div>
                            <div className="answers">
                                <span>{this.props.count && (this.props.count.comment || 0)}</span>&nbsp;réponses
                            </div>
                        </div>
                    </div>
                </div>
                {lastPostHasOwner? (
                    <div className="last-post">
                        <Link to={createLink("userProfile", lastPost.owner)}><Avatar
                            avatar={lastPost.owner.profile.avatar} gender={lastPost.owner.profile.gender}
                            alt=""/></Link>
                        <div className="wrapper-infos-last">
                            <Link className="link" to={createLink("forumTopic", {categoryParent : {slug : _.get(this.props,"match.params.slugParent") || ""}, category : {slug : _.get(this.props,"forum.slug") || "", "_id" : _.get(this.props,"forum._id")}, topic : {"_id" : _.get(this.props,"_id"), slug : _.get(this.props,"slug") || "", page : totalPage}}) + '#last-comment' }>
                                <span>Dernier message </span>
                                <span>par {lastPost.owner.username && lastPost.owner.username.length >= 15 ? lastPost.owner.username.substring(0, 15) + "..." : lastPost.owner.username}</span>
                            </Link>
                            <div className="text small medium-grey">
                                {lastPost.createdAt ? <DateSince
                                    date={lastPost.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                /> : 0}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="last-post">
                        <Avatar gender="guest" alt=""/>
                        <div className="wrapper-infos-last">
                            <div className="username-last-post">Par
                                Guest_{lastPost.authorName && lastPost.authorName.length >= 10 ? lastPost.authorName.substring(0, 10) + "..." : lastPost.authorName}</div>
                            <div
                                className="text small medium-grey">
                                {lastPost.createdAt ? <DateSince
                                    date={lastPost.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                /> : 0}
                            </div>
                        </div>
                    </div>
                )}
                {/*TODO: right*/}
                <Can action={"moderation"} subject={this.props} modelName="Topic">
                    <div className="topic-moderation answer-topic-admin-button responsive-hidden-640">
                        <Dropdown align="right" activableComponent={(
                            <Icon type="cog"/>
                        )}>
                            <ul className="dropdown-menu">
                                <Can action={"update"} subject={this.props} modelName="Topic">
                                    <li className="menu-item" onClick={() => this.setState({toggleChangeTitle: true})}><Icon
                                        type="pencil"/> Modifier le titre
                                    </li>
                                </Can>
                                <Can action={"update"} subject={this.props} modelName={"Topic"}>
                                    <li className="menu-item"
                                        onClick={() => this.setState({toggleChangeContent: true})}><Icon
                                        type="pencil"/>Modifier le contenu
                                    </li>
                                </Can>
                                <Can action={"is-pinned"} subject={this.props} modelName="Topic">
                                    <li className="menu-item"
                                        onClick={() => this.handleStatus('isPinned', !this.props.isPinned)}><Icon
                                        type="thumb-tack"/> {this.props.isPinned ? "Désépingler" : "Epingler"}</li>
                                </Can>
                                <Can action={"is-opened"} subject={this.props} modelName="Topic">
                                    <li className="menu-item"
                                        onClick={() => this.handleStatus('isOpened', !this.props.isOpened)}><Icon
                                        type={this.props.isOpened ? 'lock' : 'unlock'}/> {this.props.isOpened ? "Fermer" : "Ouvert"}
                                    </li>
                                </Can>
                                <Can action={"move"} subject={this.props} modelName="Topic">
                                    <li className="menu-item" onClick={() => this.setState({toggleMoveForum: true})}><Icon
                                        type="long-arrow-right"/> Déplacer
                                    </li>
                                </Can>
                                <Can action={"is-approved"} subject={this.props} modelName="Topic">
                                    <li className="menu-item"
                                        onClick={() => this.handleStatus('isApproved', !this.props.isApproved)}><Icon
                                        type={this.props.isApproved === false ? 'check' : 'minimize'}/> {this.props.isApproved === false ? "Accepter" : "Refuser"}
                                    </li>
                                </Can>
                                <Can action={"delete"} subject={this.props} modelName="Topic">
                                    <li className="menu-item"
                                        onClick={() => this.setState({toggleAlertDeleteArticle: true})}><Icon
                                        type="close"/> Supprimer
                                    </li>
                                </Can>
                                <Can action={"report"} subject={this.props} modelName="Topic">
                                    <li className="menu-item">
                                        <Icon type="report"/>
                                        <Report _id={this.props._id}
                                                kind={"topics"}
                                                handleReport={this.handleReport}
                                                title={this.props.title}/>
                                    </li>
                                </Can>
                            </ul>
                        </Dropdown>
                    </div>
                </Can>
                <Modal toggle={this.state.toggleAlertDeleteArticle}
                       handleClose={() => this.setState({toggleAlertDeleteArticle: false})}>
                    <Alert text="Voulez-vous vraiment supprimer ce topic ?"
                           handleClose={() => this.setState({toggleAlertDeleteArticle: false})}
                           handleDelete={this.handleAlertDeleteTopic}/>
                </Modal>
                <Modal toggle={this.state.toggleMoveForum} handleClose={() => this.setState({toggleMoveForum: false})}>
                    <MoveForum handleClose={() => this.setState({toggleMoveForum: false})}
                               handleMoveTopic={this.handleMoveTopic}
                               title={this.props.title}
                               // totalPage={totalPage}
                               // _id={this.props._id}
                               // slug={this.props.slug}
                               articleId={this.props._id}/>
                </Modal>
                <Modal toggle={this.state.toggleChangeTitle}
                       handleClose={() => this.setState({toggleChangeTitle: false})}>
                    <ChangeTitle
                        title={this.props.title}
                        articleId={this.props._id}
                        forumId={this.props.forumId}
                        type={this.props.type}
                        handleStatus={this.handleStatus}
                        handleClose={() => this.setState({toggleChangeTitle: false})}
                        reloadArticle={this.props.reloadArticle}
                    />
                </Modal>
                <Modal toggle={this.state.toggleChangeContent} handleClose={()=>this.setState({toggleChangeContent: false})}>
                    <AdvancedEditorTopic  topicId={this.props._id}
                                          forumId={this.props.forumId}
                                          handleClose={()=>this.setState({toggleChangeContent: false})} />
                </Modal>
            </div>
        )
    }

}


CardTopics.defaultProps = {
    allowed: false,
    slug: '',
    title: '',
    authorName: '',
    description: '',
    createdAt: '',
    redirect: {
        url: ''
    },
    lastComment: {
        createdAt: 0,
        authorName: '',
        owner: {
            username: '',
            avatar: '',
            slug: '',
            gender: 3,
        }
    },
    owner: {
        slug: '',
        username: '',
        avatar: '',
    }

};

const mapStateToProps = (state) => {
    return {
        forums: state.forums.forums
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    deleteForumTopic,
    updateForumTopic,
    moveForumTopic,
    reportForumTopic,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ResizeWindow(CardTopics));
